export const release = 'myhealthmoney@96dcdd7d';